import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Globe } from "lucide-react";
import OsintLinks from "../components/OsintLinks";
import { useLang } from "../i18n";

export default function OsintPage() {
  const { t } = useLang();
  const { state } = useLocation();
  const [name, setName] = useState(state?.name || "");
  return (
    <div className="space-y-6" data-testid="osint-page">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900 flex items-center gap-2"><Globe className="w-7 h-7 text-[#044CBC]" /> {t("osint.module_title")}</h1>
        <p className="text-sm text-slate-500 mt-1 max-w-2xl">{t("osint.module_subtitle")}</p>
      </div>
      <div className="ec-card p-6">
        <label className="ec-label">{t("search.name_label")}</label>
        <input className="ec-input text-base" value={name} onChange={(e) => setName(e.target.value)} placeholder={t("search.name_ph")} data-testid="osint-name-input" />
        <p className="text-xs text-slate-400 mt-2">{t("osint.module_hint")}</p>
      </div>
      <OsintLinks name={name} searchId={state?.searchId || null} initialReview={state?.review || null} />
    </div>
  );
}
